import React from 'react';
import {Grid} from "@mui/material";

export interface ISuccessfulProps {
    type: string;
}

export function Successful(props: ISuccessfulProps) {

    return (
        <>
            <div style={{width: '100%', backgroundColor: '#54C0B5', padding: '10px', marginBottom: '0px', marginTop: '20px'}}>
                <Grid container direction="row" spacing={2}>
                    <Grid item>
                        Vielen Dank, wir haben Ihren Zählerstand für {props.type} gespeichert.
                    </Grid>
                </Grid>
            </div>
        </>
    );

}